module.exports = __webpack_public_path__ + "static/media/bg.104523c0.png";